"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYtjCompany = exports.searchYtjCompany = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const errorHandling_1 = require("../../utils/errorHandling");
const customerActionTypes = require("../../actionTypes/firstLogin/customer");
const customerActions = require("../../actions/firstLogin/customer");
const actionTypes = require("../../actionTypes/firstLogin/ytj");
const actions = require("../../actions/firstLogin/ytj");
const ytjTypes = require("../../types/ytj");
function searchYtjCompany(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === actionTypes.SEARCH_YTJ_REQUEST), (0, operators_1.debounceTime)(1000), (0, operators_1.switchMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/ytj/search/${encodeURIComponent(request.payload.searchString)}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = ytjTypes.iYtjListResponse.decode(response);
        const act = validation.fold((err) => actions.searchYtjFailed((0, errorHandling_1.parseValidationError)(err)), (e) => actions.searchYtjSuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(actions.searchYtjFailed((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.searchYtjCompany = searchYtjCompany;
function getYtjCompany(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === customerActionTypes.SET_YTJ_COMPANY_REQUEST), (0, operators_1.switchMap)((request) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/ytj/${request.payload.businessId}`
    }).pipe((0, operators_1.mergeMap)(({ response }) => {
        const validation = ytjTypes.iYtjResponse.decode(response);
        const act = validation.fold((err) => customerActions.setYtjCompanyFailure((0, errorHandling_1.parseValidationError)(err)), (e) => customerActions.setYtjCompanySuccess(e));
        return (0, rxjs_1.of)(act);
    }), (0, operators_1.catchError)((err) => (0, rxjs_1.of)(customerActions.setYtjCompanyFailure((0, errorHandling_1.parseAjaxErrorResponse)(err)))))));
}
exports.getYtjCompany = getYtjCompany;
//# sourceMappingURL=ytj.js.map